import React from 'react'
import {Typography,Button, Grid, TextField} from '@mui/material';
import colors from '../../../colors' 
import * as config from '../../../config'
import Lottie from "lottie-react";
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData, setShouldDisplayConfirmationCodeTextField, setIsDirectDebitTransactionSuccessfullyCompleted} from '../../../../features/userInfo/topUpSlice'
import {selectGlobalDataState, setTransactionHasBeenMade} from '../../../../features/global/globalDataSlice'
import { sendGeneralRequest } from '../../../../features/generalRequest'
import smallLoadingAnimation from '../../../../icons/lottieAnimations/smallLoading.json'
import { makeStyles } from '@mui/styles';
import { useFormik } from 'formik'
import * as yup from 'yup'
import { texts } from '../../../general/texts'

const TopUpBankActive = (props) => 
{ 
    const dispatch = useDispatch()
    const topUpData = useSelector(selectTopUpData)
    const globalDataSliceState = useSelector(selectGlobalDataState)

    const validationSchema = yup.object({
        amount: yup
            .string(texts["placeholder-utility-amount"])
            .matches( /^\d+$/, {
                message: texts["placeholder-utility-amount"],
            })
            .required(texts["placeholder-utility-amount"]),
        ...(topUpData.shouldDisplayConfirmationCodeTextField) && {
            otp: yup
            .string(texts["prompt-insert-confirmation-code"])
            .required(texts["prompt-insert-confirmation-code"]),
        }
      });      
    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            bankId: topUpData.selectedBank.bankId,
            amount: '',
            otp: '',
            applicationId: config.default.userBrowserName
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            if(!topUpData.shouldDisplayConfirmationCodeTextField)
            {
                dispatch(sendGeneralRequest({request: {token: values.token, bankId: values.bankId, amount: values.amount, applicationId:values.applicationId}, baseUrlKey:'services', endpoint:'DirectDebit/CreditAccount'}))  
            }
            else
            {
                dispatch(sendGeneralRequest({request: {token: values.token, otp: values.otp, creditId: topUpData.creditAccountId, applicationId: values.applicationId, custom: '', bankAccount: ''}, baseUrlKey:'services', endpoint:'DirectDebit/ConfirmDirectDebitCredit'}))
            }   
        }
    })

    React.useEffect(()=> {
        if(topUpData.isDirectDebitTransactionSuccessfullyCompleted)
        {
            dispatch(setTransactionHasBeenMade(true))
            dispatch(setIsDirectDebitTransactionSuccessfullyCompleted(false))
        }
        return(() => {
            dispatch(setShouldDisplayConfirmationCodeTextField(false))
        })
    },[topUpData.isDirectDebitTransactionSuccessfullyCompleted])


    const useStyles = makeStyles({
        header:{
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            color:colors.darkBlue
        },
        cif:{
            fontSize:'1.2rem',
            fontFamily:'GerberaMedium',
            color:colors.mediumGray
        },
        fieldTitle:{
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            color:colors.darkBlue
        },
        topUpButton:{
            height:'100%',
            width:'110px',
            textTransform:'none',
            fontFamily:'GerberaBold',
            backgroundColor:colors.red,
            '&:hover':{backgroundColor:colors.red},
            color:colors.white
        },
        confirmButton:{
            height:'100%',
            width:'110px',
            textTransform:'none',
            fontFamily:'GerberaBold',
            backgroundColor:colors.lightGreen,
            color:colors.white,
            '&:hover':{backgroundColor:colors.lightGreen}
        }
    })

    const classes = useStyles()

    const handleSubmit = (e) => 
    {
        e.preventDefault()
        formik.handleSubmit()
    }
    
    return(    
        <form onSubmit={handleSubmit}>
            <Grid container  spacing={5}>
            <Grid container item md={12} alignItems='flex-start' direction='column' spacing={2}>
                <Grid item>
                    <Typography className={classes.header}>{texts["title-account-number"]}</Typography>
                </Grid>
                <Grid item >
                    <Typography className={classes.cif}>{props.bankData.cif}</Typography>
                </Grid>         
            </Grid>
            <Grid container  item md={12} alignItems='flex-start' spacing={2}>
                <Grid item><Typography className={classes.fieldTitle}>{texts["placeholder-utility-amount"]}</Typography></Grid> 
                <Grid container item direction='row' spacing={2}>
                    <Grid item><TextField id="amount" name="amount" onChange={formik.handleChange} value={formik.values.amount} error={formik.touched.amount && Boolean(formik.errors.amount)} helperText={formik.touched.amount && formik.errors.amount} color='warning' size='small' onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}/></Grid>
                    <Grid item ><Button type='submit' disabled={(topUpData.shouldDisplayConfirmationCodeTextField || topUpData.isLoading) ? true : false} className={classes.topUpButton}>{texts["title-topup"]}</Button></Grid>            
                </Grid>           
            </Grid>
            {
                topUpData.shouldDisplayConfirmationCodeTextField && <Grid container item md={12} alignItems='flex-start'  spacing={2}>
                <Grid item><Typography className={classes.fieldTitle}>{texts["prompt-insert-confirmation-code"]}</Typography></Grid>
                <Grid container item md={12} justifyContent='flex-start'>
                    <Grid  container item md={12} direction='row' spacing={2}>
                        <Grid item><TextField id="otp" name="otp" onChange={formik.handleChange} value={formik.values.otp} error={formik.touched.otp && Boolean(formik.errors.otp)} helperText={formik.touched.otp && formik.errors.otp} color='warning' size='small' onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}/></Grid>
                        <Grid item><Button type='submit' disabled={topUpData.isLoading ? true : false} className={classes.confirmButton}>{texts["button-confirm"]}</Button></Grid>            
                    </Grid>             
                </Grid>             
            </Grid>
            }                   
            </Grid>  
        </form>  
    )
}
export default TopUpBankActive